import { render, staticRenderFns } from "./survey-step-family-diagnoses.vue?vue&type=template&id=1f9ab23c"
import script from "./survey-step-family-diagnoses.vue?vue&type=script&lang=js"
export * from "./survey-step-family-diagnoses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports